<template>
    <div class="loginBox">
        <div v-if="collegeDetail" class="leftLogo flex_l">
            <img :src="collegeDetail.logo" />
            <span>{{collegeDetail.name}}</span>
        </div>
        <!-- 输入弹窗 -->
        <div class="card">
            <div class="title">登录</div>

            <div class="rowBox">
                <span class="label">账号：</span>
                <input class="longInput" :disabled="disabledStatus"  placeholder="请输入登录账号" placeholder-style="color:#999" v-model="account.name">
            </div>

            <div class="rowBox">
                <span class="label">密码：</span>
                <input class="longInput" :disabled="disabledStatus" placeholder="请输入登录密码" v-model="account.pwd" type="password">
            </div>

            <div class="rowBox">
                <span class="label">验证码：</span>
                <input class="smallInput" :disabled="disabledStatus" placeholder="请输入验证码"  v-model="account.vCode" maxlength="4">
                <img  v-if="vcode?.vcode_image" :src="'data:image/png;base64,'+ vcode?.vcode_image" alt="" class="smsCodeImg" @click="getSmsCode">
             </div>

            <button class="loginBtn" @click="userLogin" :disabled="disabledStatus">登录</button>
        </div>


        <!-- 手机号校验弹窗层 -->
        <div class="inputSmsDialog" v-if="showInputSmsDialog">
            <div class="box">
                <div class="title">
                    <span class="text">为保证账户安全，系统向您的手机号187****0352发送了验证码，请在下方输入</span>
                    <img src="../../src/assets/image/closeIcon.png"  class="closeIcon" @click="handleClose">
                </div>
                <input type="text" class="smsCodeInput" v-model="smsCode">
                <div class="footer">
                    <button class="clickBtn" @click="userSmsCodeLogin">确定</button>
                </div>
            </div>
        </div>
        <img src="../assets/image/bottomLogo.png" style="position: fixed;right: 25px;bottom: 25px;width: 200px;height: 60px" />

    </div>

</template>

<script lang="ts">
    import { ElMessage } from 'element-plus';
    import basicApi from '../public/http/index';
    import Constants from '../public/Constants';
    import {
        getLocalStorage,
        setLocalStorage,
        removeLocalStorage
    } from  '../public/storage';
    import { useRouter,onBeforeRouteUpdate  } from 'vue-router';



    // 首先，在 vue 3.0 中，生命周期是从 vue 中导出的，我们需要用到哪些，就导出哪些。
    import {
        defineComponent,
        ref,
        onBeforeMount,
        computed,
        onMounted,
        onBeforeUpdate,
        onUpdated,
        onBeforeUnmount,
        onUnmounted,
        getCurrentInstance,

        reactive
    } from "vue";
    export default {
        name: "login",

        setup() {
            const vcode = reactive({ vcodeid: '', vcode_image: '' });
            const smsCode:any = ref('');
            let showInputSmsDialog:any = ref(false);
            const account = reactive({ name: '', pwd: '', vCode: ''});
            const router = useRouter();
            let disabledStatus:any = ref(false);
            let collegeId: any = ref('');
            let collegeDetail = ref('');

            onMounted(()=>{
                localStorage.removeItem('collegeDetail');
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('access_token');
                localStorage.removeItem('user');
                localStorage.removeItem('accountid');
                localStorage.removeItem('background');

                loginInit(router.currentRoute.value)

                // console.log(router.currentRoute.value.query,'router.currentRoute.value.query')
                //
                //     // 跳转带token登录
                //     if(router.currentRoute.value.query?.access_token && router.currentRoute.value.query?.collegeId) {
                //         let access_token: any = router.currentRoute.value.query.access_token;
                //         if(router.currentRoute.value.query.collegeId.length != 24){
                //             ElMessage({
                //                 message:'collegeId参数有误,请重新进入',
                //                 type: 'warning'
                //             });
                //         }else{
                //             setLocalStorage('access_token', access_token);
                //             verifyToken(access_token);
                //             setLocalStorage('collegeId',router.currentRoute.value.query.collegeId);
                //         }
                //     }
                //
                // if(!router.currentRoute.value.query?.collegeId){
                //     disabledStatus.value = true;
                //     alert('请从所属高校就业信息网跳转进行登录！');
                //     console.log(disabledStatus,'disabledStatus')
                // }else {
                //     collegeId.value = router.currentRoute.value.query.collegeId;
                //     setLocalStorage('collegeId',collegeId.value);
                //      get_college_detail();
                // }
                //
                // basicApi.getTopSystemCode().then((res: any) => {
                //     vcode.vcode_image = res.data.vcode_image;
                //     vcode.vcodeid = res.data.vcodeid;
                // }).catch((err: any) => {
                //     console.log('getData', err)
                // });
            });

            const  get_school_security_login = function (accountName: string,collegeId: string) {
                basicApi.school_security_login(accountName,collegeId).then((res)=>{
                    console.log(res,'res')
                    if(res.data.value){
                        setLocalStorage('collegeId',collegeId);
                        let params={
                            login_type: 'username',
                            account_type: 'teacher',
                            username: account.name,
                            password: account.pwd,
                            vcode_verify: {
                                vcodeid:  vcode.vcodeid,
                                vcode_text: account.vCode,
                            },
                            login_source: '高校管理后台',
                        };

                        basicApi.postUserLogin(params).then((res)=>{
                            accountToken(res.data.value);
                        }).catch((err)=>{
                            getSmsCode();
                            account.vCode = '';
                            console.log(err,'rrrr')
                        })
                    }else{
                        ElMessage({
                            message:'账号不属于当前高校，请返回就业信息网重新登录',
                            type: 'warning'
                        });
                    }
                })
            };

            const getSmsCode = function(){
                basicApi.getTopSystemCode().then((res)=>{
                    vcode.vcode_image = res.data.vcode_image;
                    vcode.vcodeid = res.data.vcodeid;
                })
            };

            const userLogin = function(){
                if(!account.name){
                    ElMessage({
                        message:'请输入用户名',
                        type: 'warning'
                    });
                    return
                }

                if(!account.pwd){
                    ElMessage({
                        message:'请输入密码',
                        type: 'warning'
                    });
                    return
                }

                if(!account.vCode){
                    ElMessage({
                        message:'请输入验证码',
                        type: 'warning'
                    });
                    return
                }

                get_school_security_login(account.name,collegeId.value);
            };

            // 获取token
            const accountToken = function(code:string){
                let params={
                    'grant_type': 'authorization_code',
                    'account_type': 'teacher',
                    'code':code
                };
                basicApi.getAccountToken(params).then((res)=>{
                    setLocalStorage('access_token',res.data.access_token);
                    setLocalStorage('refresh_token',res.data.refresh_token);
                    verifyToken(res.data.access_token)
                })
            };

            // 验证token有效
            const verifyToken =  function(access_token: string){
                let params={
                    client_id: Constants.clientId,
                    access_token: access_token
                };
                basicApi.getVerifyToken(params).then((res)=>{
                    if(res.status){
                        verifyAccountIsLock();
                    }
                })
            };

            // 验证 token是否加锁
            const verifyAccountIsLock =  function (){
                basicApi.postVerifyAccountIsLock().then((res)=>{
                    if(!res.data.value){
                        getTeacherInfo();
                    }else {
                        let login_name;
                        let localList:any = window.localStorage;
                        getLocalStorage('safecode_' + account.name) ? login_name =  getLocalStorage('safecode_' + account.name).split('_')[1] : '';
                        for(let i = 0 ; i <localList.length; i++){
                            if(localList.key(i).split('_')[1] == account.name){
                                login_name =localList.key(i).split('_')[1]
                            }
                        }
                        if(login_name){
                            let unlock_access_token = getLocalStorage('safecode_' + account.name);
                            basicApi.post_unlock_access_token(unlock_access_token).then((res)=>{
                                console.log(res,'加锁验证是否通过');
                                getTeacherInfo();
                            })
                        }else {
                            // 当前账号已加锁
                            verifySendSms();
                        }
                    }
                })
            };

            // 安全验证 发送验证码
            const verifySendSms =  function (){
                basicApi.postVerifySendSms().then((res)=>{
                    showInputSmsDialog.value = true;
                })
            };

            // 短信验证码弹窗关闭
            const handleClose =function (){
                removeLocalStorage('access_token');
                removeLocalStorage('refresh_token');
                showInputSmsDialog.value = false;
                getSmsCode();
            };

            // 获取教师信息
            const getTeacherInfo =function (){
                basicApi.getTeacher().then((res)=>{
                    console.log(res.data,'res')
                    if(res.data){
                        setLocalStorage('accountid',res.data.accountid);
                        setLocalStorage('user',res.data);
                        router.push("/home/homepage");
                    }else {
                        // 未获取到教师信息
                    }
                })
            };

            // 获取高校信息
            const get_college_detail = function () {
                let collegeId = getLocalStorage('collegeId');
                basicApi.get_college_detail(collegeId).then((res)=>{
                    console.log(res,'res.data获取高校信息')
                    setLocalStorage('collegeDetail',res.data);
                    collegeDetail.value = res.data;

                })
            }

            // 用户验证码登录
            const userSmsCodeLogin =function (){
                if(!smsCode.value){
                    ElMessage({
                        message:'请输入验证码',
                        type: 'warning'
                    });
                    return
                }
                basicApi.smsCodeLogin(smsCode.value).then((res)=>{
                    if(res.data.value){
                        let user_key;
                        user_key = 'safecode_' + account.name;
                        setLocalStorage(user_key,res.data.value);
                        getTeacherInfo();
                    }
                }).catch((err: any) => {
                    console.log('getData', err);
                    removeLocalStorage('access_token');
                    removeLocalStorage('refresh_token');
                    showInputSmsDialog.value = false;
                });
            };

            //在setup中
            onBeforeRouteUpdate((to) => {
                loginInit(to)
            });

            const  loginInit =function (router: any) {
                getSmsCode();

                console.log('router.query',router.query)
                // 跳转带token登录
                if(router.query?.access_token && router.query?.collegeId) {
                    let access_token: any = router.query.access_token;
                    if(router.query.collegeId.length != 24){
                        ElMessage({
                            message:'collegeId参数有误,请重新进入',
                            type: 'warning'
                        });
                    }else{

                        setLocalStorage('access_token', access_token);
                        verifyToken(access_token);
                        setLocalStorage('collegeId',router.query.collegeId);
                        get_college_detail();

                    }
                }
                else if(!router.query?.collegeId){
                    disabledStatus.value = true;
                    alert('请从所属高校就业信息网跳转进行登录！');
                    console.log(disabledStatus,'disabledStatus')
                }else {
                    if(router.query.collegeId.length != 24){
                        ElMessage({
                            message:'collegeId参数有误,请重新进入',
                            type: 'warning'
                        });
                    }else {
                        collegeId.value = router.query.collegeId;
                        setLocalStorage('collegeId',collegeId.value);
                        get_college_detail();
                    }
                }


            };

            return{
                vcode,
                smsCode,
                account,
                showInputSmsDialog,
                getSmsCode,
                userLogin,
                handleClose,
                userSmsCodeLogin,
                disabledStatus,
                collegeDetail,
            }
        },
    }
</script>

<style scoped>
    .flex_c{display: flex;flex-direction: row;align-items: center;flex-wrap: wrap;justify-content:center;}
    .flex_l{display: flex;flex-direction: row;align-items: center;flex-wrap: wrap;justify-content:flex-start;}
    .flex_r{display: flex;flex-direction: row;align-items: center;flex-wrap: wrap;justify-content:flex-end;}
    .flex_s{display: flex;flex-direction: row;align-items: center;flex-wrap: wrap;justify-content:space-between;}
    .loginBox{
        overflow: hidden;
        position: fixed;
        width:100%;
        height:100%;
        background: url(../assets/image/page_default_bg.png) no-repeat;
        background-size:cover;
    }

    .loginBox .logo{
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 2;
        width: 338px;
        height: 68px;
    }

    .loginBox .card{
        position: absolute;
        top: 300px;
        left: 0;
        right: 0;
        margin: auto;
        padding: 15px;
        width: 450px;
        background: #fff;
        border-radius: 2px;
    }

    .loginBox .card  .title{
        margin-top: 20px;
        margin-bottom: 20px;
        height: 45px;
        line-height: 45px;
        font-size: 18px;
        color: #333;
        text-align: center;
    }
    .loginBox .card .rowBox{
        margin: 0 15px 20px;
    }

    .loginBox .card .rowBox .label{
        padding-right: 10px;
        display: inline-block;
        width: 80px;
        height: 50px;
        line-height: 50px;
        text-align: right;
    }

    .loginBox .card .rowBox .longInput{
        width: calc(100% - 110px);
    }

    .loginBox .card .rowBox .smallInput{
        width: calc(100% - 220px);
    }

    .loginBox .card .rowBox .longInput,.loginBox .card .rowBox .smallInput{
        padding: 0 15px;
        height: 50px;
        line-height: 50px;
        border: 1px rgb(235,235,235) solid;
        box-sizing: border-box;
    }

    .loginBox .card .rowBox input{
        outline-color: rgb(235,235,235);
    }

    .loginBox .card .rowBox .smsCodeImg{
        margin-left: 10px;
        width: 100px;
        height: 50px;
        vertical-align: middle;
        cursor: pointer;
    }

    .loginBox .card  .loginBtn{
        margin: 50px 15px 20px;
        height: 50px;
        line-height: 50px;
        width: calc(100% - 30px);
        color: #fff;
        border-radius: 5px;
        border: none;
        box-sizing: border-box;
        overflow: hidden;
        background-color: rgb(18,39,94);
    }


    /* 短信验证码弹窗层 */
    .loginBox .inputSmsDialog{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0,0,0,0.5);
    }

    .loginBox .inputSmsDialog .box{
        position: absolute;
        top: 25%;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 99999;
        max-width: 600px;
        background-color: #fff;
        box-shadow: 1px 1px 50px rgb(0 0 0 / 30%);
    }

    .loginBox .inputSmsDialog .box .title{
        padding: 5px 10px 0 10px ;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        color: #333;
        background-color: #F8F8F8;
    }
    .loginBox .inputSmsDialog .box .title .text{
        display: inline-block;
        width: calc(100% - 30px);
    }

    .loginBox .inputSmsDialog .box .closeIcon{
        margin-top: 10px;
        vertical-align: top;
        height: 16px;
        width: 16px;
    }

    .loginBox .inputSmsDialog .box .smsCodeInput{
        height: 36px;
        line-height: 36px;
        margin: 10px 0;
        width: 230px;
        border:1px solid #e6e6e6;
        border-radius: 2px;
    }

    .loginBox .inputSmsDialog .box .footer{
        padding-bottom: 10px;
        margin-right: 15px;
        text-align: right;

    }

    .loginBox .inputSmsDialog .box .footer .clickBtn{
        margin-top: 20px;
        height: 28px;
        line-height: 28px;
        width: 60px;
        border: none;
        color: #fff;
        background-color: #1E9FFF;
    }


    /* 移动端 */
    @media screen and (max-width: 600px) {
        .loginBox .logo{
            height: 40px;
            width: 200px;
        }

        .loginBox .card{
            top: 20%;
            width: 92%;
            padding: 10px 0;
        }

        .loginBox .card .title{
            margin-top: 10px;
            margin-bottom: 10px;
        }

        .loginBox .card .rowBox{
            margin: 0 0  15px 0;
        }

        .loginBox .card .rowBox .smallInput{
            width: calc(100% - 200px);
            font-size: 14px;
            padding: 0 5px;
        }

        .loginBox .card .rowBox .smsCodeImg{
            width: 80px;
        }

        .loginBox .inputSmsDialog .box{
            margin: 0 15px;
        }

        .loginBox .inputSmsDialog .box .title{
            padding-bottom: 3px;
            line-height: 24px;
            height: auto;
        }

        .loginBox .inputSmsDialog .box .title .text{
            margin-right: 5px;
            text-align: left;
        }

        .loginBox .inputSmsDialog .box .smsCodeInput{
            margin: 20px 0 5px;
            width: 190px;
        }

        .loginBox .inputSmsDialog .box .footer{
            display: inline-block;
        }

        .loginBox .inputSmsDialog .box .footer .clickBtn{
            position: relative;
            top: 1px;
            height: 36px;
            line-height: 36px;
        }

    }
    .leftLogo{
        width: 600px;
        height: 60px;
        position: absolute;
        left: 0;
        top: 18px;
        color: white;
        font-size: 30px;
    }
    .leftLogo img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-right: 12px;
        margin-left: 12px;
    }
    .leftLogo span
    {
        line-height: 60px;
        font-weight: bold;
    }

</style>
